import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=8826916e&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=8826916e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8826916e",
  null
  
)

export default component.exports